import React, { useEffect, useRef, useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Toast } from 'primereact/toast';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Layout from '../common/Layout';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';

const Questions = () => {

    const { quizId, sectionId } = useParams()
    
    const toast = useRef(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    
    const [quizQuestionData, setQuizQuestionData] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
        getQuizQuestions()
    }, [])

    const getQuizQuestions = () => {
        ApiHelper.get(`${API_ENDPOINTS.QUIZ_QUESTIONS}/${sectionId}`).then((res) => {
            console.log('res: ', res);
            if (res.status === 200) {
                setQuizQuestionData(res?.data?.data)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const nameBodyTemplate = (rowData) => {
        return (
            rowData?.question ? (
                <div style={{ display: "flex", alignItems: "center", gap: "10px", color:'blue', cursor:'pointer' }} onClick={() => navigate(`/quiz/${quizId}/section/${rowData.sectionId}/questions/edit/${rowData.questionId}`)} >
                    {rowData?.question}
                </div>
            ) : null
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.isActive ? 'bg-success' : 'bg-danger'} `}>
                {rowData.isActive ? 'Active' : 'Inactive'}
            </span>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <button onClick={() => navigate(`/quiz/${quizId}/section/${rowData.sectionId}/questions/edit/${rowData.questionId}`)} className="btn btn-primary btn-sm me-2"> <i class="bi bi-pencil-square"></i> </button>
                <button onClick={() => confirmDeleteDailog(rowData.questionId)} className="btn btn-danger btn-sm"> <i class="bi bi-trash"></i> </button>
            </>
        );
    };

    const confirmDeleteDailog = (id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteQuestion(id),
        });
    };

    const deleteQuestion = (id) => {
        ApiHelper.delete(`${API_ENDPOINTS.QUIZ_QUESTIONS}/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
                getQuizQuestions();
            }
        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response?.data?.message, life: 3000 });
        });
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

  return (
    <>
        <Toast ref={toast} />
        <ConfirmDialog />
        <Layout>
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                    <div class="d-flex justify-content-between align-items-center py-3">
                        <h4 class="fw-bold py-3 mb-2"><span class="text-muted fw-light"> <p className="breadcrumb-item active mb-0" aria-current="page">Manage Questions</p> </span></h4>
                        <div>
                            <Link to={`/quiz/${quizId}/section`} class="btn btn-secondary">⬅ Go Back</Link>
                            <Link to={`/quiz/${quizId}/section/${sectionId}/questions/add`} class="btn btn-primary mx-2">Add new Question</Link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={quizQuestionData} tableStyle={{ minWidth: '50rem' }} >
                                        <Column body={serialNoTemplate} header='S.NO' />
                                        <Column sortable header='Question' body={nameBodyTemplate} field='question' />
                                        <Column sortable header='Status' body={statusBodyTemplate} />
                                        <Column sortable header='Action' body={actionBodyTemplate} />
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
        
    </>
  )
}

export default Questions